const STEPS = [
  {
    n: "A",
    title: "Mathematically Grounded",
    body: "Every direction begins with rigorous problem formulation — clear assumptions, precise objectives, and a principled analytical framework before any implementation.",
  },
  {
    n: "B",
    title: "Computational Thinking",
    body: "We translate structure into computation: algorithms, models, and numerical methods built to be robust, interpretable, and extensible across related problems.",
  },
  {
    n: "C",
    title: "Practical Execution",
    body: "Ideas are validated through software, experiments, and iteration. We treat engineering quality as a first-class research output, not a downstream afterthought.",
  },
];

export default function Approach() {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative py-24 md:py-36 border-t border-white/10 overflow-hidden"
    >
      <div className="absolute inset-0 nl-grid-bg opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500">
                03 / Approach
              </span>
              <span className="flex-1 h-px bg-white/10" />
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-tighter font-medium text-white leading-[1.04]">
              How we work.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-8 md:pt-16">
            <p className="text-lg md:text-xl text-zinc-300 font-light leading-relaxed max-w-2xl">
              We combine mathematically grounded research, computational
              thinking, and practical execution — prioritizing flexibility,
              technical rigor, and long-term innovation potential over
              short-term narrative.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s) => (
            <div
              key={s.n}
              data-testid={`approach-step-${s.n}`}
              className="bg-[#070707] p-8 md:p-12 flex flex-col min-h-[280px] md:min-h-[360px]"
            >
              <div className="flex items-start justify-between mb-10">
                <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-zinc-500">
                  Step / {s.n}
                </span>
                <span className="w-8 h-px bg-white/30" />
              </div>
              <h3 className="font-heading text-xl md:text-2xl tracking-tight font-medium text-white mb-4 leading-tight">
                {s.title}
              </h3>
              <p className="text-[15px] text-zinc-400 leading-relaxed font-light">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
